var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("2、下列各项中引起资产和权益同时增加的经济业务是（　）。")]),_vm._v(" A、购入材料，货款未付  "),_c('br'),_c('br'),_vm._v(" B、以银行存款支付采购办公用品款"),_c('br'),_c('br'),_vm._v(" C、以银行存款偿还银行借款"),_c('br'),_c('br'),_vm._v(" D、用银行存款购入机器一台 ")])
}]

export { render, staticRenderFns }